export interface MenuItem {
  id: number;
  title: string;
  icon: string;
  menuType: EnumMenuType;
}

export interface UserToggleAbility {
  key: string;
  display_name: string;
}

export interface PopupInfoModel {
  item: any;
  ftype: EnumPopupFunctions;
  callback?: (item: any) => void;
  props?: any;
  array_branches?: BranchModel[];
}

export enum EnumPopupFunctions {
  ADD_USER,
  EDIT_USER,
  USER_DETAIL,
  ADD_BRANCH,
  BRANCH_DETAIL,
  BRANCH_DELETE,
  BRANCH_LIST_DELETE,
  ADD_SHIFT,
  EDIT_SHIFT,
  TL_USER_LOGIN_DIALOG,
  TL_USER_LOGIN_DIALOG_REDIRECTION,
  TL_FORCE_CLOSE_DIALOG,
  TL_END_SHIFT_DIALOG,
  MAIN_MENU_PASSWORD_REQUIRED_LOGIN_DIALOG,
  BM_REPORT_DETAIL,
  ADMIN_REPORT_DETAIL,
  ALERT_DIALOG,
  CHANGE_PASSWORD_SELF,
  CHANGE_PASSWORD_ADMIN,
  CLOSE,
  UNKNWON,
}

export enum EnumUserAcces {
  ADMIN,
  SHIFT_PLANER,
  BRANCH_MANAGER,
  TEAM_LEAD,
  TEMP_TEAM_LEAD,
  EMPLOYEE,
  DEV,
  UNKNOWN,
}

export enum EnumUserEnable {
  ENABLE,
  DISABLE,
}

export interface UserAccessModel {
  type: EnumUserAcces;
  key: string;
  id: string;
  display_name: string;
  color_scheme: string;
}

export enum EnumMenuType {
  USERS,
  BRANCHES,
  REPORTS,
  REPORT_EMPLOYEE,
  REPORT_BRANCH,
  SHIFTS,
  SETTINGS,
  USER_DETAIL,
  TEAM_LEAD_WORKSTATION,
  TEAM_LEAD_ATTENDANCE_LIST,
  BRANCH_MANAGER_WORKSTATION,
  BRANCH_MANAGER_REPORT_DETAIL,
  SHIFT_PLANER_WORKSTATION,
  REPORT_DETAIL,
  PROFILE,
  CHANGE_PASSWORD_SELF,
  CHANGE_PASSWORD_ADMIN,
  EMPLOYEE_SCHEDULE,
  EMPLOYEE_HISTORY_REPORT,
  REPORT_RAW,
  UNKNOWN,
}

export enum EnumIcons {
  Branches,
  Users,
  Projects,
  Calendar,
  Documents,
  Reports,
  Back,
}
export interface UserModel {
  user_id: string;
  employee_id: string;
  email_id: string;
  profile_pic_url: string;
  first_name: string;
  last_name: string;
  mobilePrefix: string;
  mobile: string;
  address: string;
  working_status: UserStatusModel;
  user_city: string;
  user_state: string;
  user_zipcode: string;
  permanent_branch_id: string;
  permanant_branch: BranchModel;
  role: UserAccessModel;
  tempRole?: UserAccessModel;
  password?: string;
  hourly_rate: number;
  pref_time: PreferredTimeModel[];
  toggleAbility: UserToggleAbility;
  about_us: string;
  gender: GenderTypeModel;
}

export interface ReportModel {
  report_id: number;
  title: string;
  department_id: number;
  department: string;
  signatory: string;
  date?: Date;
  description: string;
  filename: string;
  shift_plan?: ShiftPlanModel;
  team_lead_info?: UserModel;
  approved_by_info?: UserModel;
  total_hours?: string;
}

export interface BranchModel {
  branch_id: string;
  name: string;
  address: string;
  phone: string;
  contact_name: string;
  contact_email: string;
  contact_phone: string;
  isActivityRunning?: boolean;
}

export interface ShiftModel {
  shift_id: string;
  title: string;
  start_time: string;
  end_time: string;
}

export interface ShiftPlanModel {
  plan_id?: string;
  log_id?: string;
  branch_id?: string;
  shift_id?: string;
  team_lead_id?: string;
  date: Date;
  shift: ShiftModel;
  branch: BranchModel;
  array_employees: ShiftPlanEmployee[];
  log?: ShiftLogModel;
}

export interface ShiftLogModel {
  id: string;
  plan_id: string;
  approval_status: boolean;
  approved_by_user_id: string;
  comments: string;
  end_at: string;
}

export enum EnumUserStatus {
  UNKNOWN,
  WORKING,
  ON_VACATION,
  SICK,
  FREE,
  RESIGNED,
}

export interface UserStatusModel {
  id: string;
  status: EnumUserStatus;
  key: string;
  display_name: string;
  color_scheme: string;
}

export enum EnumEmployeeShiftState {
  UNKNOWN,
  WORKING,
  ON_BREAK,
  SHIFT_ENDED,
}

export interface WorkStateModel {
  status: EnumEmployeeShiftState;
  display_name: string;
  color_scheme: string;
}
export interface ShiftPlanEmployee {
  id?: string;
  plan_id?: string;
  user_id?: string;
  employee_added_by_id?: string;
  employee_start_at?: string;
  employee_end_at?: string;
  user: UserModel;
  current_entry?: ShiftEmployeeEntries;
  current_state: EnumEmployeeShiftState;
  array_shift_entries: ShiftEmployeeEntries[];
}

export enum EnumWorkingFunction {
  WEB_API_FUNCTIONS,
  SHIFT_PLAN_FUNCTIONS,
  UNKNOWN,
}

export enum EnumShiftPlanFunctions {
  UNKNOWN,
  START_EMPLOYEE_TIMER,
  STOP_EMPLOYEE_TIMER_TIMER,
  END_EMPLOYEE_SHIFT,
}

export enum EnumWebAPIFunctions {
  UNKNOWN,
}

export interface ShiftEmployeeEntries {
  entry_id?: string;
  user_id: string;
  shift_log_id: string;
  start_time: string;
  end_time?: string;
  ended_by_id?: string;
  branch_name?: string;
}

export enum EnumActivityIndicatorState {
  START_STOP_SHIFT,
  END_SHIFT,
  NOT_RUNNING,
}

export enum EnumTempBranchRequestStatus {
  PENDING,
  ACCEPTED,
  REJECTED,
  UNKNWON,
}

export interface TempBranchRequestStatusModel {
  status: EnumTempBranchRequestStatus;
  key: string;
  display_name: string;
  color_scheme: string;
}

export interface TempBranchPendingRequestModel {
  user: UserModel;
  request_status: TempBranchRequestStatusModel;
  activity_indicator?: boolean;
  message?: string;
}

export enum EnumAlertDialogType {
  NEUTRAL,
  POSITIVE,
  NEGATIVE,
}
export interface AlertDialogModel {
  type: EnumAlertDialogType;
  alert_title: string;
  alert_description: string;
  dismiss_button_text: string;
}

export interface ReportDetailModel {
  user: UserModel;
  start_time: string;
  end_time: string;
  working_hours: string;
  break_hours: string;
  earning: string;
}

export interface PreferredTimeModel {
  day_id?: string;
  day_key: string;
  day_display: string;
  start_time: string;
  end_time: string;
}

export interface EmployeeScheduleModel {
  plan_id: string;
  plan_date: string;
  employee_start_time: string;
  employee_end_time: string;
  team_lead_email: string;
  branch_name: string;
  branch_address: string;
  shift_name: string;
}

export interface EmployeeHistoryModel {
  employee_id: string;
  first_name: string;
  last_name: string;
  email: string;
  array_dailyLogs: EmployeeDailyLogModel[];
}

export interface EmployeeDailyLogModel {
  shift_log_id: string;
  shift_date: string;
  branch_name: string;
  hourly_rate: string;
  array_entries: ShiftEmployeeEntries[];

  total_hours?: string;
  break_hours?: string;
  earning?: string;
}

export enum EnumReportType {
  DAILY,
  WEEKLY,
  MONTHLY,
  UNKNOWN,
}
export interface ReportTypeModel {
  type: EnumReportType;
  key: string;
  display_name: string;
}

export enum EnumGenderType {
  MALE,
  FEMALE,
  UNKNOWN,
}
export interface GenderTypeModel {
  type: EnumGenderType;
  key: string;
  display_name: string;
}

export interface EmployeeReportModel {
  user: UserModel;
  array_logEntries: ShiftEmployeeEntries[];
  total_time_in_seconds: number;
  total_earning: number;
  working_hours: string;
}

export interface BranchReportModel {
  branch: BranchModel;
  total_hours: number;
  working_hours: string;
  array_log_entries: ShiftEmployeeEntries[];
}

export interface RawReportModel {
  user: UserModel;
  entry: ShiftEmployeeEntries;
  date: string;
  branch: string;
  start_time: string;
  end_time: string;
  total_time: string;
}
